
const state = {
  activityList: null
}
const getters = {
  getActivityList: state => state.activityList
}

const mutations = {
  setActivityList (state, activityList) { state.activityList = activityList }
}
const actions = {
  getActivityList: function ({commit}) {
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js